<div class="dialog-container green-theme">
    <div class="dialog-header">
      <h4 class="dialog-heading">Edit Episodes</h4>
      <button type="button" class="close-button" (click)="close()">
        <svg width="26px" height="24px" viewBox="0 0 26 24" version="1.1" xmlns="http://www.w3.org/2000/svg"
          xmlns:xlink="http://www.w3.org/1999/xlink">
          <g id="Nav-Desktop" stroke="none" stroke-width="1" fill="none" fill-rule="evenodd" stroke-linecap="round"
            stroke-linejoin="round">
            <g id="Genre" transform="translate(-1438.000000, -32.000000)" class="inner-stroke" stroke="#FFFFFF">
              <g id="Genre-Options">
                <g id="Close" transform="translate(1439.000000, 32.000000)">
                  <path d="M24,0 L0,24" id="Path"></path>
                  <path d="M0,0 L24,24" id="Path"></path>
                </g>
              </g>
            </g>
          </g>
        </svg>
      </button>
    </div>
  
    <mat-dialog-content>
      <!-- <app-loader *ngIf="loading" color="#50e3c2"></app-loader> -->
      <div class="dialog-body">
        <!-- <h3 class="title"><ng-container *ngFor="let user of data.users.slice(0,5); let i = index; trackBy:userTrackBy">{{user.getFullName()}}{{data.users.length > i+1 ? ', ':''}}</ng-container>{{data.users.length > 5 ? '+' + (data.users.length - 5) :''}}</h3> -->
        <div *ngIf="!isSeasonSelected" class="add-to-folder form-container"> 
          <!-- <p class="label">Available Groups<span class="deselect" (click)="deselectGroups()"><small>Deselect all ({{selectedCount}})</small></span></p> -->
          <p class="label">Select a Season</p>
          <!-- <input class="search"  id="searchGroup" (keyup)="getGroups()" -->
          <!-- <input class="search"  id="searchGroup"
            placeholder="Find a group"> -->
            <!-- [formControl]="searchControl"> -->
            <ul class="list" id="availableGroups">
                <!-- <ul class="list" *ngIf="!searchingGroups" id="availableGroups"> -->
            <li *ngFor="let season of show.seasons; let i = index">
                <!-- <span class="check-text" (click)="createProEpisode(season)"> -->
                <span class="check-text" (click)="selectSeason(season)">
                    <small>
                        Season {{ season.season_number }}
                    </small>
                </span>
            </li>
          </ul>
          <!-- <div class="no-groups" *ngIf="!searchingGroups && groups.length <= 0">
            <p>There are currently no groups available. Create a new group to add your track version</p>
          </div> -->
          <!-- <app-loader *ngIf="searchingGroups" color="#50e3c2"></app-loader> -->
        </div>
        <div *ngIf="isSeasonSelected && selectedSeason">
          <span class="label" style="display: flex; justify-content: flex-end;">
            <small class="check-text" (click)="openEpisodeInfoModal(selectedSeason, null)">Add New Episode</small>
          </span>
          <div class="add-to-folder form-container"> 
            <!-- <p class="label">Available Groups<span class="deselect" (click)="deselectGroups()"><small>Deselect all ({{selectedCount}})</small></span></p> -->
            <div style="display: flex; justify-content: space-between">
                  <p class="label">Episodes</p>
                  <p class="label">Partner Group</p>
            </div>
            <!-- <input class="search"  id="searchGroup" (keyup)="getGroups()" -->
            <!-- <input class="search"  id="searchGroup"
              placeholder="Find a group"> -->
              <!-- [formControl]="searchControl"> -->
              <ul class="list" id="availableGroups">
                  <!-- <ul class="list" *ngIf="!searchingGroups" id="availableGroups"> -->
              <li *ngFor="let episode of selectedSeason.episodes; let i = index">
                  <!-- <span class="check-text" (click)="createProEpisode(season)"> -->
                    <div style="display: flex; justify-content: space-between">
                      <span class="check-text" (click)="openEpisodeInfoModal(selectedSeason, episode)">
                          <small>
                              {{ episode.title }}
                          </small>
                      </span>
                      <span class="check-text">
                          <small>
                            {{ findPartnerGroupName(episode.partnerGroup_id) }}
                          </small>
                      </span>
                    </div>
              </li>
            </ul>
            <!-- <div class="no-groups" *ngIf="!searchingGroups && groups.length <= 0">
              <p>There are currently no groups available. Create a new group to add your track version</p>
            </div> -->
            <!-- <app-loader *ngIf="searchingGroups" color="#50e3c2"></app-loader> -->
          </div>
        </div>
        <!-- <p class="note">Select or deselect groups to add {{data.users[0].is_client ? 'client(s)':'artist(s)'}} to group</p> -->
        <div class="form-col buttons">
          <button class="form-button">Create</button>
          <!-- <button class="form-button" (click)="save()" [disabled]="selectedCount==0">Save</button> -->
          <button class="form-button form-button-cancel" (click)="close()">Cancel</button>
        </div>
      </div>
    </mat-dialog-content>
  </div>
  